export enum JOBS_NAV {
  crawling = 'crawling',
}
